var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.2332 48.416L70.8999 65.0827C70.3999 70.1827 69.9999 74.0827 60.9665 74.0827H19.0332C9.99987 74.0827 9.59987 70.1827 9.09987 65.0827L7.76654 48.416C7.49987 45.6494 8.36654 43.0827 9.93321 41.116C9.96654 41.0827 9.96654 41.0827 9.99987 41.0493C11.8332 38.816 14.5999 37.416 17.6999 37.416H62.2999C65.3999 37.416 68.1332 38.816 69.9332 40.9827C69.9665 41.016 69.9999 41.0494 69.9999 41.0827C71.6332 43.0494 72.5332 45.616 72.2332 48.416Z",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6641 38.8509V21.6842C11.6641 10.3509 14.4974 7.51758 25.8307 7.51758H30.0641C34.2974 7.51758 35.2641 8.78424 36.8641 10.9176L41.0974 16.5842C42.1641 17.9842 42.7974 18.8509 45.6307 18.8509H54.1307C65.4641 18.8509 68.2974 21.6842 68.2974 33.0176V38.9842",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4297 57.416H48.563",
    stroke: "#1E729F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDocument);
export default __webpack_public_path__ + "static/media/iconDocument.921147e78e3681ae58f1dc813bd69551.svg";
export { ForwardRef as ReactComponent };